import { Locality } from "./localities.model";
import { Site } from "./sites.model";
import { Article } from "./articles.model";
import { Tiers } from "./tiers.model";

export class PointOfSale {
    id: number;
    name: string;
    status: string;
    surface: string;
    locality: Locality;
    tiers: Tiers[];
    site: Site;
    articles: Article[];

    constructor() {
        this.locality = new Locality();
        this.site = new Site();
    }
}


export class PointOfSaleForm {
    id: number;
    name: string;
    status: string;
    surface: string;
    tiers:  number[];
    locality: Locality;
    articles: number[];
    site: number;

    constructor() { }
}